<template>
    <div id="phlebSignupDiv">
        <HeaderVue />
        <div class="inner-page phleb-signup">
            <div class="container">
                <div class="row">
                    <div class="col-sm-8">
                        <div class="lab-benefits phlebotomists-signup">
                            <h3>Hello Phlebotomist, 
                                <br> Come and Sign Up with us</h3>
                                <br>
                            <!-- <p>In partnering with Labotist, Phlebotomists</p> -->
                            <ul>
                                <li>
                                    <span class="number-circle">1</span>Become micro-entrepreneurs (Be their own boss)</li>
                                <li>
                                    <span class="number-circle">2</span>Work on a schedule that suits them</li>
                                <li>
                                    <span class="number-circle">3</span>Work within the area that is close to home & family</li>
                                <li>
                                    <span class="number-circle">4</span>Get state of the art training and tools</li>
                                <li>
                                    <span class="number-circle">5</span>Use indigenous mobile app that enables technology driven sample collection
                                </li>
                                <li>
                                    <span class="number-circle">6</span>Increase their income 
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-sm-4">
                        <div class="sign-up">
                            <div class="signup-title">
                                <h4>Sign Up</h4>
                                <p>Join us as a Labotist Phlebotomist</p>
                            </div>
                            <div class="form-content line-textbox">
                                <form data-vv-scope="signup">
                                    <div class="form-group">
                                        <input class="form-control" type="text" name="pincode" id="pincode" v-model="pincode" data-vv-as="pincode" v-validate="'required|numeric|max:6|min:6'" placeholder="Pincode (Chennai & Bengaluru)">
                                        <span v-show="errors.has('signup.pincode')" class="text-danger">{{ errors.first('signup.pincode') }}</span>
                                    </div>
                                    <div class="form-group">
                                        <input class="form-control" type="text" name="firstname" id="firstname" v-model="firstname" data-vv-as="first name" v-validate="'required|alpha|max:50'" placeholder="First Name">
                                        <span v-show="errors.has('signup.firstname')" class="text-danger">{{ errors.first('signup.firstname') }}</span>
                                    </div>
                                    <div class="form-group">
                                        <input class="form-control" type="text" name="lastname" id="lastname" v-model="lastname" data-vv-as="last name" v-validate="'required|alpha|max:50'" placeholder="Last Name">
                                        <span v-show="errors.has('signup.lastname')" class="text-danger">{{ errors.first('signup.lastname') }}</span>
                                    </div>
                                    <div class="form-group">
                                        <input class="form-control" type="email" name="email" id="email" v-model="email" data-vv-as="email address" v-validate="'required|email'" placeholder="Email Address">
                                        <span v-show="errors.has('signup.email')" class="text-danger">{{ errors.first('signup.email') }}</span>
                                    </div>
                                    <!-- <div class="form-group">
                                        <input class="form-control" type="text" name="mobile" id="mobile" v-model="mobile" data-vv-as="mobile no." v-validate="'required|numeric|max:10'" placeholder="Mobile No">
                                        <span v-show="errors.has('signup.mobile')" class="text-danger">{{ errors.first('signup.mobile') }}</span>
                                    </div> -->
                                    <div class="form-group">
                                        <input class="form-control" type="text" name="phone" id="phone" v-model="phone" data-vv-as="phone no." v-validate="'required|numeric|max:10|min:10'" placeholder="Phone No">
                                        <span v-show="errors.has('signup.phone')" class="text-danger">{{ errors.first('signup.phone') }}</span>
                                    </div>
                                    <div class="form-group">
                                        <input class="form-control" type="text" name="address" id="address" v-model="address" data-vv-as="address" v-validate="'required'" placeholder="Address">
                                        <span v-show="errors.has('signup.address')" class="text-danger">{{ errors.first('signup.address') }}</span>
                                    </div>
                                    <div class="form-group">
                                        <input class="form-control" type="text" name="city" id="city" v-model="city" data-vv-as="city" v-validate="'required|alpha_spaces|max:50'" placeholder="City">
                                        <span v-show="errors.has('signup.city')" class="text-danger">{{ errors.first('signup.city') }}</span>
                                    </div>
                                    <div class="form-group">
                                        <input class="form-control" type="text" name="state" id="state" v-model="state" data-vv-as="state" v-validate="'required|alpha_spaces|max:50'" placeholder="State">
                                        <span v-show="errors.has('signup.state')" class="text-danger">{{ errors.first('signup.state') }}</span>
                                    </div>
                                    <div class="row">
                                        <div class="col-sm-6">
                                            <button class="btn  btn-link full-width" @click.prevent="reset()" type="reset">Reset</button>
                                        </div>
                                        <div class="col-sm-6">
                                            <button class="btn btn-primary full-width" @click.prevent="save()" :disabled="(errors.any())">Send</button>                                        
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <FooterVue />
    </div>
</template>

<script>
import HeaderVue from '@/components/web/Header'
import FooterVue from '@/components/web/Footer'

export default {
  name: 'Phlebsignup',
  components: {
    HeaderVue,
    FooterVue
  },
  data () {
    return {
      pincode: '',
      firstname: '',
      lastname: '',
      email: '',
      mobile: '',
      phone: '',
      address: '',
      city: '',
      state: '',
      success: false
    }
  },
  beforeCreate () { },
  methods: {
    save: function () {
      this.$validator.validateAll('signup').then(function (result) {
        if (result) {
          try {
            let data = {
              firstName: this.firstname,
              lastName: this.lastname,
              emailAddress: this.email,
              mobileNumber: this.mobile,
              phoneNumber: this.phone,
              address: this.address,
              cityName: this.city,
              stateName: this.state,
              pincode: this.pincode
            }
            Promise.resolve(this.$POST('patient/phlebSignup', data)).then(function (res) {
              if (res.response_code === 0) {
                this.success = true
                // location.reload()
                this.$Simplert.open({
                  title: 'Success',
                  message: `We have received your details.We will touch with you soon.`,
                  type: 'warning',
                  disableOverlayClick: true,
                  showXclose: true,
                  useConfirmBtn: false,
                  customCloseBtnText: 'OK'
                })
                this.reset()
              }
            }.bind(this)).catch(function (err) {
              console.error(err)
              this.$Simplert.open({
                title: 'Oops',
                message: `Something went wrong please mail us support@labotist.com`,
                type: 'warning',
                disableOverlayClick: true,
                showXclose: true,
                useConfirmBtn: false,
                customCloseBtnText: 'OK'
              })
              // alert('Something went wrong please mail us support@labotist.com')
            }.bind(this))
          } catch (e) {
            console.error(e)
          }
        }
      }.bind(this)).catch(() => {
        console.log('errors exist while save lab form', this.errors)
      })
    },
    reset: function () {
      this.pincode = ''
      this.firstname = ''
      this.lastname = ''
      this.email = ''
      this.mobile = ''
      this.phone = ''
      this.address = ''
      this.city = ''
      this.state = ''
      setTimeout(function () {
        this.errors.items = []
      }.bind(this), 30)
    }
  },
  mounted () {
    this.$hidePageLoading()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/web/Public/Phlebsignup.vue